import React from "react";
import { CategoryManageSelectedItemsTemplate } from "themes/application/categories/components";

function CategoryManageSelectedItems(props) {
    return <CategoryManageSelectedItemsTemplate {...props} />;
}

export default CategoryManageSelectedItems;
